import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'acabim-admin-update-asset-type-classification',
  templateUrl: './update-asset-type-classification.component.html',
  styleUrls: ['./update-asset-type-classification.component.scss']
})
export class UpdateAssetTypeClassificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
